import React, { useEffect, useContext, useState, useMemo } from "react"; // Import useMemo
import { DropdownOption, Dropdown } from "@abb/abb-common-ux-react";
import getTimestamps from "../../../util";
import { RootContext } from "../../../contexts/root-context";
import filterJsonData from "./Rim-filter.json";


import "./Rim-filter.css";

function RimFilter() {
    const { setstartTS, setendTS, setSelectedSubstation ,setSelectedDevice,rimData} = useContext(RootContext);
  

  

    const [selectedSingle, setSelectedSingle] = useState("Last 1 hour");
    const [selectedSubstationDropdown, setSelectedSubstationDropdown] = useState("");

    const [selectedDeviceDropdown, setSelectedDeviceDropdown] = useState("");

    const [uniqueSubstations, setUniqueSubstations] = useState([]);
    const [uniqueDevices, setUniqueDevices] = useState([]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                

                const substations =rimData.map(item => item.substation).filter(Boolean);
                const uniqueSub = [...new Set(substations)];
                setUniqueSubstations(uniqueSub);


                const devices =rimData.map(item => item.device_name).filter(Boolean);
                const unique = [...new Set(devices)];
                setUniqueDevices(unique);

                if (unique.length > 0) {
                    setSelectedDeviceDropdown(unique[0]);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [rimData]);

    const getFilterTime = (filterVal) => {
        setSelectedSingle(String(filterVal[0].label));
        setstartTS(getTimestamps(filterVal[0].value).startDate);
        setendTS(getTimestamps(filterVal[0].value).endDate);
    };

    const getSubstation = (filterVal) => {
        const newSelectedSubstation = String(filterVal[0].label);

        setSelectedSubstationDropdown(newSelectedSubstation);

        setSelectedSubstation(newSelectedSubstation === "All Substations" ? "" : newSelectedSubstation);
    };

    
  
    const getAssetName = (filterVal) => {
    const newSelectedDevice = String(filterVal[0].label);
    setSelectedDeviceDropdown(newSelectedDevice);
    const contextDevice = newSelectedDevice === "All Devices" ? "" : newSelectedDevice;
    setSelectedDevice(contextDevice); // 👈 updates shared context
    };


    const deviceOptions = useMemo(() => {
        return ["All Devices", ...uniqueDevices];
    }, [uniqueDevices]);

    const substationOptions = useMemo(() => {
        return ["All Substations", ...uniqueSubstations];
    }, [uniqueSubstations]);

    return (
  
        <div className="Rim-filter">
            <div className="Rim-filter-row" style={{ height: "100px" }}>
                <div className="col-5 col-m-12 col-s-12">
                    <div className="Rim-filter-header">{filterJsonData.title.value}</div>
                </div>
                <div className="col-7 col-m-12 col-s-12">
                    <div className="Rim-filters-group ">

                        {filterJsonData.Substation[0].isEnabled && (
                            <Dropdown
                                id={filterJsonData.Substation[0].id}
                                className="Rim-filter-dropdown col-s-12"
                                placeholder={`${filterJsonData.Substation[0].placeholder}: ${selectedSubstationDropdown || filterJsonData.Subdefault.defaultlabel}`}
                            
                                value={selectedSubstationDropdown} // Use local state for dropdown display
                                onChange={getSubstation}
                            >
                                {substationOptions.map((substation) => (
                                    <DropdownOption
                                        key={substation}
                                        label={substation}
                                        value={substation}
                                    />
                                ))}
                            </Dropdown>
                        )}

                        {filterJsonData.Asset[0].isEnabled && (
                            <Dropdown
                                id="device_name_dropdown"
                                className="Rim-filter-dropdown col-s-12"
                                placeholder={`Asset: ${selectedDeviceDropdown ||filterJsonData.Assetdefault.defaultlabel}`}
                              
                                value={selectedDeviceDropdown}
                                onChange={getAssetName}
                            >
                                {deviceOptions.map(device => (
                                    <DropdownOption
                                        key={device}
                                        label={device}
                                        value={device}
                                    />
                                ))}
                            </Dropdown>
                        )}

                        {filterJsonData.TimePeriod[0].isEnabled && (
                            <Dropdown
                                id={filterJsonData.TimePeriod[0].id}
                                className="Rim-filter-dropdown col-s-12"
                                placeholder={`${filterJsonData.TimePeriod[0].placeholder}: ${selectedSingle || filterJsonData.Timedefault.defaultlabel}`}
                          
                                value={selectedSingle}
                                onChange={getFilterTime}
                            >
                                {filterJsonData.TimePeriod[0].options
                                    .filter((o) => o.isEnabled)
                                    .map((o) => (
                                        <DropdownOption
                                            key={o.title}
                                            label={o.title}
                                            value={o.value}
                                        />
                                    ))}
                            </Dropdown>
                        )}
                    </div>
                </div>
            </div>
            </div>
    
    );
}

export default RimFilter;